import get from './get'

const hasHash = () => {
  const hash = location.hash
  if (hash) {
    let scrollNum = -60
    if (get.ww() === 'pc') {
      scrollNum = -100
    }
    setTimeout(() => {
      window.scrollBy(0, scrollNum)
    }, 10)
  }
}

export default hasHash
